export const translations = {
  nl: {
    nav: {
      home: "Home",
      experiences: "Games",
      about: "Over Ons",
      contact: "Contact",
      getStarted: "Start Nu",
      vrAtLocation: "VR op jouw locatie",
      priceAnchor: "Al vanaf € 20,- p.p.",
    },
    hero: {
      title: "Maak jullie volgende activiteit",
      subtitle: "legendarisch",
      description: "Een complete VR-arcade, bij jou op locatie.",
      bookExperience: "Vraag direct een voorstel aan",
      socialProof: "5.0 uit 21+ Google reviews van enthousiaste teams",
      whatsappCta: "Stuur ons een WhatsApp",
      viewGames: "Bekijk Games",
      microCta: "Ontdek de mogelijkheden in 1 minuut",
      reassurance:
        "Binnen 24 uur een voorstel \u00b7 vanaf 6 personen \u00b7 landelijke dekking \u00b7 100% pleziergarantie",
      teamBuildingBadge: "Perfect voor Teambuilding",
      priceAnchor: "Al vanaf € 20,- p.p.",
      priceAnchorNote: "o.b.v. volle capaciteit van 18 personen",
    },
    friction: {
      items: [
        {
          title: "Past op elke locatie",
          description: "Wij regelen de complete opbouw en hebben minimaal 6 m\u00b2 vrije ruimte nodig.",
        },
        {
          title: "Voor iedereen toegankelijk",
          description: "Zowel fanatieke gamers als absolute non-gamers zijn binnen een minuut mee.",
        },
        {
          title: "Volledig ontzorgd",
          description: "Ervaren begeleiding aanwezig \u2013 jij hoeft nergens naar om te kijken.",
        },
      ],
    },
    groupSize: {
      title: "Hoe groot is jullie groep?",
      subtitle: "Kies je groepsgrootte \u2013 we zetten de juiste opzet en begeleiding klaar in je voorstel.",
      options: ["6\u201315 personen", "16\u201330 personen", "30+ personen"],
      cta: "Vraag voorstel aan",
      selected: "Gekozen",
      prefill: "Wij zijn een groep van",
    },
    audience: {
      title: "Wat organiseer jij?",
      subtitle: "Kies je richting \u2013 we stemmen de games, opzet en begeleiding daar volledig op af.",
      business: {
        badge: "Zakelijk",
        title: "Ik organiseer een bedrijfsuitje of teambuilding",
        description:
          "Een uitje waar je team echt iets aan overhoudt: samenwerken onder druk, communiceren en daarna nog dagen napraten over dat ene moment.",
        bullets: [
          "Zichtbaar sterker teamgevoel",
          "Iedereen doet mee, ook de niet-gamers",
          "Nul organisatiestress: wij regelen alles",
        ],
        cta: "Bekijk de teambuilding-opzet",
      },
      party: {
        badge: "Priv\u00e9 & feest",
        title: "Ik organiseer een feest of partij",
        description:
          "De wow-factor waar je gasten je nog jaren aan herinneren. Van personeelsfeest tot verjaardag: iedereen wil nog \u00e9\u00e9n keer die headset op.",
        bullets: [
          "Direct entertainment vanaf minuut \u00e9\u00e9n",
          "Spectaculair om te doen \u00e9n om te kijken",
          "Geschikt voor alle leeftijden en niveaus",
        ],
        cta: "Bekijk feest & partij",
      },
    },
    teambuilding: {
      badge: "Teambuilding",
      title: "Perfect voor",
      titleHighlight: "Teambuilding",
      subtitle:
        "Een uitje dat niemand vergeet in plaats van een middag die niemand mist. Onze VR-avonturen dwingen je team tot samenwerken, communiceren en \u00e9\u00e9n gezamenlijk doel \u2013 en dat voel je daarna terug op de werkvloer.",
      cta: "Plan Jouw Teambuilding Event",
      whatsappCta: "Stuur ons een WhatsApp",
      benefits: {
        collaboration: {
          title: "Samenwerking & Communicatie",
          description: "VR escape rooms en co-op missies die teamwork en effectieve communicatie vereisen.",
        },
        bonding: {
          title: "Team Bonding",
          description: "Gedeelde ervaringen die collega's dichter bij elkaar brengen en memorabele momenten creëren.",
        },
        competition: {
          title: "Gezonde Competitie",
          description:
            "Shooter games en uitdagingen voor friendly competition die motivatie en enthousiasme stimuleren.",
        },
        creativity: {
          title: "Creatief Denken",
          description: "Puzzels en uitdagingen die out-of-the-box denken en probleemoplossend vermogen ontwikkelen.",
        },
      },
    },
    experiences: {
      title: "Onze",
      titleHighlight: "VR Games",
      description:
        "Elke game lost iets anders op: de \u00e9\u00e9n dwingt je team tot overleggen, de ander zorgt voor pure adrenaline en gelach. Wij adviseren welke combinatie past bij jouw groep en doel.",
      action: {
        title: "Action",
        description:
          "Ervaar intense actie in onze VR shooter en combat games. Perfect voor actie-liefhebbers die adrenaline zoeken.",
        features: ["Intense gevechten", "Co-op missies", "Adrenaline-gevuld"],
      },
      adventure: {
        title: "Adventure",
        description:
          "Ga op avontuur in prachtige werelden vol mysteries en epische quests. Ontdek nieuwe plekken en beleef spannende verhalen.",
        features: ["Epische verhaallijnen", "Prachtige werelden", "Ga op verkenning"],
      },
      kidFriendly: {
        title: "Casual",
        description:
          "Leuke en laagdrempelige VR-ervaringen geschikt voor iedereen. Kleurrijk, boeiend en toegankelijk voor alle leeftijden.",
        features: ["Fun-for-all", "Makkelijk te spelen", "Hilariteit gegarandeerd"],
      },
      immersiveTitle: "Full Body Immersive",
      immersiveTitleEnd: "Ervaring",
      immersiveDescription:
        "We leveren een complete meeslepende ervaring met haptische feedback vesten die je elke impact laten voelen, realistische VR controllers voor intuïtieve gameplay, en geavanceerde bewegingssensoren die elke beweging volgen voor echt interactieve VR-avonturen.",
      hapticVest: {
        title: "Haptische Feedback Vesten",
        description:
          "Voel elke impact, explosie en hit met geavanceerde haptische technologie. Ervaar ware onderdompeling terwijl het vest in realtime reageert op gebeurtenissen in het spel.",
        features: ["Real-time impact feedback", "Instelbare intensiteit", "Draadloze technologie"],
      },
      metaQuestControllers: {
        title: "Meta Quest Touch Pro Controllers",
        description:
          "Premium handheld VR controllers met intuïtieve bediening. Ergocomfort ontworpen om uitgebreide gameplay sessies te ondersteunen.",
        features: ["Precisie tracking", "Ergonomisch design", "Draadloze technologie"],
      },
      motionSensors: {
        title: "Full Body Motion Sensors",
        description:
          "Geavanceerde bewegingstracking legt elke beweging nauwkeurig vast. Duik, buig en beweeg natuurlijk terwijl je hele lichaam je VR-avatar bestuurt.",
        features: ["360° bewegingstracking", "Sub-millimeter precisie", "Natuurlijke bewegingsregistratie"],
      },
      weComeTo: {
        title: "Wij Komen Naar Jou",
        description:
          "Geen reistijd, geen gedoe met een externe locatie en geen risico op een lauwe opkomst. Onze mobiele VR arcade komt naar jouw kantoor, zaal of feestlocatie: wij bouwen op, begeleiden de hele sessie en ruimen weer op. Jij hoeft alleen de datum te kiezen.",
        features: [
          "Professionele on-site setup en ondersteuning",
          "Geschikt voor groepen van alle groottes",
          "Flexibele planning en maatwerk",
        ],
      },
    },
    about: {
      title: "Over",
      description1:
        "Wij zijn op een missie om next-level VR-ervaringen te leveren die mensen nooit zullen vergeten. Door onze meeslepende VR arcade direct naar jouw locatie te brengen, maken we het gemakkelijk voor bedrijven, scholen en gemeenschapsgroepen om onvergetelijke momenten te creëren.",
      description2:
        "Van teambuilding-uitdagingen tot spannende entertainment, onze samengestelde selectie van VR-games combineert cutting-edge technologie met boeiende gameplay om gedeelde ervaringen te creëren die banden versterken en opwinding wekken.",
      mission: {
        title: "Onze Missie",
        description:
          "Mensen next-level ervaringen geven die ze nooit zullen vergeten door middel van meeslepende VR-technologie.",
      },
      innovation: {
        title: "Innovatie Eerst",
        description: "We blijven voorop lopen met de nieuwste VR-technologie en de meest boeiende game-ervaringen.",
      },
      quality: {
        title: "Kwaliteit Service",
        description: "Professionele setup, volledige ondersteuning en naadloze ervaringen voor elk evenement.",
      },
      team: {
        title: "Ons Team",
        subtitle: "Maak kennis met de mensen achter PlayfieldVR",
        members: [
          {
            name: "Jan Angel",
            bio: "Ik geloof dat technologie mensen bij elkaar brengt en onvergetelijke momenten kan creëren. Mijn passie voor VR wil ik inzetten om deze ervaringen op elke gewenste locatie toegankelijk te maken, zodat iedereen samen kan genieten en spelen.",
          },
          {
            name: "Marc Zwolsman",
            bio: "Gamen is volgens mij de toekomst van interactief entertainment. Met PlayfieldVR wil ik evenementen veranderen in unieke belevenissen die plezier en teamwork versterken, en zo blijvende herinneringen creëren.",
          },
        ],
      },
    },
    contact: {
      title: "Neem",
      titleHighlight: "Contact Op",
      description:
        "Vertel kort wat je van plan bent. Je zit nergens aan vast: je krijgt binnen 24 uur een voorstel op maat met programma, duur en prijs.",
      emailUs: "E-mail Ons",
      callUs: "Bel Ons",
      whatsappUs: "App Ons",
      whatsappCta: "Stuur ons een WhatsApp",
      whatsappSubtitle: "Snel & laagdrempelig contact",
      location: "Locatie",
      locationText: "Actief in heel Nederland",
      formTitle: "Stuur Ons een Bericht",
      formDescription:
        "Datum nog niet zeker? Geen probleem \u2013 laat je gegevens achter en we denken vrijblijvend mee. Duurt minder dan 1 minuut.",
      priceAnchor: "Al vanaf € 20,- p.p.",
      priceAnchorNote: "o.b.v. volle capaciteit van 18 personen",
      form: {
        name: "Naam",
        namePlaceholder: "Jouw naam",
        email: "E-mail",
        emailPlaceholder: "jouw@email.nl",
        phone: "Telefoon",
        phonePlaceholder: "+31 6 12345678",
        company: "Bedrijf/Organisatie",
        companyPlaceholder: "Jouw bedrijf",
        message: "Bericht (optioneel)",
        messagePlaceholder: "Bijv. teambuilding met 15 collega\u2019s in oktober, op kantoor in Utrecht...",
        submit: "Versturen",
        submitting: "Versturen...",
      },
      success: "Hartelijk dank voor je aanvraag!",
      successDescription: "We streven ernaar om binnen 24 uur contact met je op te nemen.",
      error: "Er is iets misgegaan",
      errorDescription: "Probeer het later opnieuw.",
      unexpectedError: "Er is iets misgegaan. Probeer het later opnieuw.",
    },
    thankYou: {
      title: "Bedankt voor je aanvraag!",
      description:
        "We hebben je aanvraag goed ontvangen en nemen binnen 24 uur contact met je op om alle details door te spreken.",
      backToHome: "Terug naar de homepagina",
    },
    footer: {
      description:
        "Next-level VR-ervaringen direct naar jouw locatie geleverd. Onvergetelijke herinneringen creëren door middel van meeslepende technologie.",
      quickLinks: "Snelle Links",
      legal: "Juridisch",
      privacyPolicy: "Privacybeleid",
      termsOfService: "Servicevoorwaarden",
      cookiePolicy: "Cookiebeleid",
      copyright: "Alle rechten voorbehouden.",
      faq: "Veelgestelde Vragen",
      faqItems: [
        {
          question: "Wat is PlayfieldVR?",
          answer:
            "PlayfieldVR is een 100% mobiele VR-service. Wij komen naar jouw locatie met professionele VR-apparatuur voor teambuilding, bedrijfsuitjes en evenementen.",
        },
        {
          question: "Hoeveel personen kunnen er deelnemen?",
          answer:
            "Wij kunnen groepen van elke grootte bedienen. Neem contact met ons op voor een maatwerkoplossing voor jouw evenement.",
        },
        {
          question: "Welke VR-games bieden jullie aan?",
          answer:
            "Wij hebben een uitgebreide selectie van escape rooms, shooters en adventure games. Bekijk onze Games pagina voor het volledige overzicht.",
        },
        {
          question: "Wat zijn de kosten?",
          answer:
            "De kosten zijn afhankelijk van de groepsgrootte, duur en gekozen games. Vraag een vrijblijvende offerte aan via ons contactformulier.",
        },
        {
          question: "Waar zijn jullie actief?",
          answer:
            "Wij zijn actief in heel Nederland en komen naar elke gewenste locatie: kantoren, evenementenlocaties, scholen en meer.",
        },
      ],
    },
    legal: {
      privacy: {
        title: "Privacybeleid",
        lastUpdated: "Laatst bijgewerkt",
        backToHome: "Terug naar Home",
        intro: {
          title: "Introductie",
          content:
            "Bij PlayfieldVR respecteren we jouw privacy en nemen we de bescherming van je persoonsgegevens serieus. Dit privacybeleid legt uit welke gegevens we verzamelen, hoe we deze gebruiken en welke rechten je hebt.",
        },
        dataCollection: {
          title: "Welke Gegevens Verzamelen We?",
          content: "We verzamelen alleen gegevens die je vrijwillig met ons deelt via ons contactformulier:",
          items: [
            "Naam en contactgegevens (e-mail, telefoon)",
            "Bedrijfsnaam (optioneel)",
            "Bericht of vraag die je ons stuurt",
            "IP-adres en browser informatie (automatisch verzameld)",
          ],
        },
        dataUsage: {
          title: "Hoe Gebruiken We Deze Gegevens?",
          content: "Je gegevens worden uitsluitend gebruikt voor:",
          items: [
            "Het beantwoorden van je vragen en boekingsaanvragen",
            "Het communiceren over onze VR-ervaringen en diensten",
            "Het verbeteren van onze website en dienstverlening",
            "Het voldoen aan wettelijke verplichtingen",
          ],
        },
        dataRetention: {
          title: "Hoe Lang Bewaren We Gegevens?",
          content:
            "We bewaren je persoonsgegevens maximaal 2 jaar na je laatste contact met ons, tenzij we wettelijk verplicht zijn deze langer te bewaren. Je kunt altijd verzoeken om je gegevens eerder te laten verwijderen.",
        },
        rights: {
          title: "Jouw Rechten",
          content: "Onder de AVG (Algemene Verordening Gegevensbescherming) heb je de volgende rechten:",
          items: [
            "Recht op inzage: Je kunt opvragen welke gegevens we van jou hebben",
            "Recht op correctie: Je kunt onjuiste gegevens laten corrigeren",
            "Recht op verwijdering: Je kunt verzoeken om je gegevens te laten verwijderen",
            "Recht op beperking: Je kunt de verwerking van je gegevens laten beperken",
            "Recht op bezwaar: Je kunt bezwaar maken tegen de verwerking",
          ],
        },
        cookies: {
          title: "Cookies",
          content:
            "Onze website gebruikt functionele cookies voor taalvoorkeur en YouTube embeds voor game video's. Voor meer informatie, zie ons Cookiebeleid.",
        },
        contact: {
          title: "Contact",
          content:
            "Voor vragen over je privacy of om je rechten uit te oefenen, neem contact met ons op via het contactformulier of e-mail ons direct.",
        },
      },
      terms: {
        title: "Algemene Voorwaarden",
        lastUpdated: "Laatst bijgewerkt",
        backToHome: "Terug naar Home",
        intro: {
          title: "Introductie",
          content:
            "Deze algemene voorwaarden zijn van toepassing op alle diensten en VR-ervaringen aangeboden door PlayfieldVR. Door gebruik te maken van onze diensten ga je akkoord met deze voorwaarden.",
        },
        bookings: {
          title: "Boekingen & Annuleringen",
          content: "Bij het boeken van een VR-ervaring gelden de volgende voorwaarden:",
          items: [
            "Boekingen zijn pas definitief na ontvangst van onze schriftelijke bevestiging",
            "Annulering tot 24 uur voor de geplande tijd is kosteloos",
            "Bij annulering binnen 24 uur brengen we 50% van het totaalbedrag in rekening",
            "Bij no-show brengen we 100% van het totaalbedrag in rekening",
            "Prijswijzigingen behouden we ons het recht voor, bevestigde boekingen blijven tegen de overeengekomen prijs",
          ],
        },
        age: {
          title: "Leeftijdsbeperkingen",
          content:
            "Voor een veilige en verantwoorde VR-ervaring hanteren wij leeftijdsrichtlijnen die per game kunnen verschillen. Let op het volgende:",
          items: [
            "Minimumleeftijd per VR-game: Elke VR-ervaring heeft een eigen aanbevolen minimumleeftijd, gebaseerd op intensiteit, inhoud en fysieke belasting. Deze leeftijdsgrens staat duidelijk vermeld bij elke game.",
            "Kinderen onder de aangegeven leeftijd mogen niet deelnemen aan de betreffende VR-ervaring.",
            "Kinderen jonger dan 12 jaar hebben altijd toestemming van een ouder of voogd nodig.",
            "Een begeleidende volwassene moet aanwezig zijn tijdens de VR-sessie van kinderen onder 12 jaar.",
          ],
        },
        health: {
          title: "Gezondheid & Veiligheid",
          content: "VR kan impact hebben op je gezondheid. We adviseren geen VR te gebruiken bij:",
          items: [
            "Epilepsie of gevoeligheid voor flikkerende beelden",
            "Ernstige motion sickness of duizeligheid",
            "Zwangerschap",
            "Hart- of bloeddrukproblemen",
            "Recente operaties of blessures",
            "Onder invloed van alcohol of drugs",
          ],
        },
        safety: {
          title: "Veiligheidsregels",
          content: "Om een veilige en prettige ervaring te garanderen voor iedereen:",
          items: [
            "Volg alle instructies van ons personeel op",
            "Respecteer de VR-apparatuur en andere deelnemers",
            "Meld onmiddellijk als je je niet lekker voelt",
            "Hou je aan de maximale speeltijd die we adviseren",
            "Schade door nalatigheid of opzet wordt verhaald op de gebruiker",
          ],
        },
        liability: {
          title: "Aansprakelijkheid",
          content:
            "PlayfieldVR is niet aansprakelijk voor persoonlijk letsel of schade aan eigendommen wanneer gebruikers zich aan onze veiligheidsregels en instructies houden. Bij bewust negeren van instructies vervalt elke aansprakelijkheid van PlayfieldVR.",
        },
        law: {
          title: "Toepasselijk Recht",
          content:
            "Op deze voorwaarden is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.",
        },
      },
      cookies: {
        title: "Cookiebeleid",
        lastUpdated: "Laatst bijgewerkt",
        backToHome: "Terug naar Home",
        intro: {
          title: "Wat Zijn Cookies?",
          content:
            "Cookies zijn kleine tekstbestanden die op je apparaat worden opgeslagen wanneer je onze website bezoekt. Ze helpen ons om de website beter te laten functioneren en jouw gebruikservaring te verbeteren.",
        },
        functional: {
          title: "Functionele Cookies",
          content: "Deze cookies zijn noodzakelijk voor het functioneren van de website:",
          items: [
            "Taalvoorkeur (Nederlands/Engels) - zodat de site jouw gekozen taal onthoudt",
            "Sessie cookies - voor het correct functioneren van formulieren en navigatie",
            "Beveiliging - om spam en misbruik te voorkomen",
          ],
        },
        analytics: {
          title: "Analytische Cookies (Optioneel)",
          content: "We gebruiken mogelijk analytische cookies om te begrijpen hoe bezoekers onze website gebruiken:",
          items: [
            "Pagina bezoeken en populaire content",
            "Gebruikersduur en bounce rate",
            "Verwijzende websites",
            "Deze data is geanonimiseerd en wordt alleen gebruikt voor website optimalisatie",
          ],
        },
        thirdParty: {
          title: "Cookies van Derde Partijen",
          content: "Onze website kan cookies van derden plaatsen:",
          items: [
            "YouTube - voor het afspelen van game preview video's",
            "Social media widgets (Facebook, Instagram, LinkedIn, Twitter) - als je deze gebruikt",
            "Deze partijen hebben hun eigen privacybeleid",
          ],
        },
        manage: {
          title: "Cookies Beheren",
          content:
            "Je kunt cookies beheren via je browserinstellingen. Let op: het uitschakelen van functionele cookies kan de werking van onze website beïnvloeden. Raadpleeg de help-functie van je browser voor instructies.",
        },
        moreInfo: {
          title: "Meer Informatie",
          content:
            "Voor meer informatie over hoe we met je gegevens omgaan, zie ons Privacybeleid. Voor vragen over cookies kun je contact met ons opnemen.",
        },
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      experiences: "Games",
      about: "About Us",
      contact: "Contact",
      getStarted: "Get Started",
      vrAtLocation: "VR at your location",
      priceAnchor: "From € 20,- p.p.",
    },
    hero: {
      title: "Make your next outing",
      subtitle: "legendary",
      description: "A complete VR arcade, at your location.",
      bookExperience: "Request a proposal now",
      socialProof: "5.0 from 21+ Google reviews by enthusiastic teams",
      whatsappCta: "Send us a WhatsApp",
      viewGames: "View Games",
      microCta: "Explore the options in 1 minute",
      reassurance: "Proposal within 24 hours \u00b7 from 6 people \u00b7 nationwide coverage \u00b7 100% fun guarantee",
      teamBuildingBadge: "Perfect for Team Building",
      priceAnchor: "From € 20,- p.p.",
      priceAnchorNote: "based on full capacity of 18 people",
    },
    friction: {
      items: [
        {
          title: "Fits any location",
          description: "We handle the entire setup and only need 6 m\u00b2 of free space.",
        },
        {
          title: "Accessible for everyone",
          description: "Hardcore gamers and complete non-gamers are up and running in a minute.",
        },
        {
          title: "Fully taken care of",
          description: "Experienced hosts on site \u2013 you don't have to worry about a thing.",
        },
      ],
    },
    groupSize: {
      title: "How big is your group?",
      subtitle: "Pick your group size \u2013 we prepare the right setup and hosting in your proposal.",
      options: ["6\u201315 people", "16\u201330 people", "30+ people"],
      cta: "Request a proposal",
      selected: "Selected",
      prefill: "We are a group of",
    },
    audience: {
      title: "What are you organising?",
      subtitle: "Pick your direction \u2013 we tailor the games, setup and hosting around it.",
      business: {
        badge: "Business",
        title: "I'm organising a company outing or team building",
        description:
          "An outing your team actually gains something from: collaborating under pressure, communicating, and reliving that one moment for days.",
        bullets: [
          "Visibly stronger team spirit",
          "Everyone joins in, even the non-gamers",
          "Zero organising stress: we handle everything",
        ],
        cta: "See the team building setup",
      },
      party: {
        badge: "Private & parties",
        title: "I'm organising a party or celebration",
        description:
          "The wow factor your guests will remember for years. From staff parties to birthdays: everyone wants one more turn with the headset.",
        bullets: [
          "Instant entertainment from minute one",
          "Spectacular to play and to watch",
          "Suitable for all ages and skill levels",
        ],
        cta: "See parties & celebrations",
      },
    },
    teambuilding: {
      badge: "Team Building",
      title: "Perfect for",
      titleHighlight: "Team Building",
      subtitle:
        "An outing nobody forgets instead of an afternoon nobody misses. Our VR adventures force your team to collaborate, communicate and chase one shared goal \u2013 and you feel it back at work afterwards.",
      cta: "Plan Your Team Building Event",
      whatsappCta: "Send us a WhatsApp",
      benefits: {
        collaboration: {
          title: "Collaboration & Communication",
          description: "VR escape rooms and co-op missions that require teamwork and effective communication.",
        },
        bonding: {
          title: "Team Bonding",
          description: "Shared experiences that bring colleagues closer together and create memorable moments.",
        },
        competition: {
          title: "Healthy Competition",
          description: "Shooter games and challenges for friendly competition that drive motivation and enthusiasm.",
        },
        creativity: {
          title: "Creative Thinking",
          description: "Puzzles and challenges that develop out-of-the-box thinking and problem-solving skills.",
        },
      },
    },
    experiences: {
      title: "Our",
      titleHighlight: "VR Games",
      description:
        "Every game solves something different: one forces your team to communicate, another delivers pure adrenaline and laughter. We advise which mix fits your group and goal.",
      action: {
        title: "Action",
        description: "Experience intense action in our VR shooter and combat games. Perfect for adrenaline seekers.",
        features: ["Intense combat", "Co-op missions", "Adrenaline-packed"],
      },
      adventure: {
        title: "Adventure",
        description:
          "Embark on thrilling adventures in beautiful worlds full of mysteries and epic quests. Discover new places and exciting stories.",
        features: ["Epic storylines", "Beautiful worlds", "Exploration"],
      },
      kidFriendly: {
        title: "Casual",
        description:
          "Fun and safe VR experiences perfect for the whole family. Colorful, engaging, and accessible for all ages.",
        features: ["Family fun", "Easy to play", "Colorful worlds"],
      },
      immersiveTitle: "Full Body Immersive",
      immersiveTitleEnd: "Experience",
      immersiveDescription:
        "We deliver a complete immersive experience with haptic feedback vests that let you feel every impact, realistic VR controllers for intuitive gameplay, and advanced motion sensors that track your every move for truly interactive VR adventures.",
      hapticVest: {
        title: "Haptic Feedback Vests",
        description:
          "Feel every impact, explosion, and hit with advanced haptic technology. Experience true immersion as the vest responds to in-game events in real-time.",
        features: ["Real-time impact feedback", "Adjustable intensity", "Wireless technology"],
      },
      metaQuestControllers: {
        title: "Meta Quest Touch Pro Controllers",
        description:
          "Premium handheld VR controllers with intuitive controls. Ergocomfort designed to support extended gameplay sessions.",
        features: ["Precision tracking", "Ergonomic design", "Wireless technology"],
      },
      motionSensors: {
        title: "Full Body Motion Sensors",
        description:
          "Advanced motion tracking captures every movement with precision. Dodge, duck, and move naturally as your full body controls your VR avatar.",
        features: ["360° motion tracking", "Sub-millimeter precision", "Natural movement capture"],
      },
      weComeTo: {
        title: "We Come to You",
        description:
          "No travel time, no hassle with an external venue and no risk of a half-empty turnout. Our mobile VR arcade comes to your office, hall or party venue: we set up, host the whole session and clear away. All you pick is the date.",
        features: [
          "Professional on-site setup and support",
          "Accommodates groups of all sizes",
          "Flexible scheduling and customization",
        ],
      },
    },
    about: {
      title: "About",
      description1:
        "We're on a mission to deliver next-level VR experiences that people will never forget. By bringing our immersive VR arcade directly to your location, we make it easy for companies, schools, and community groups to create unforgettable moments.",
      description2:
        "From team-building challenges to thrilling entertainment, our curated selection of VR games combines cutting-edge technology with engaging gameplay to create shared experiences that strengthen bonds and spark excitement.",
      mission: {
        title: "Our Mission",
        description: "Give people next-level experiences they'll never forget through immersive VR technology.",
      },
      innovation: {
        title: "Innovation First",
        description: "We stay ahead with the latest VR technology and most engaging game experiences.",
      },
      quality: {
        title: "Quality Service",
        description: "Professional setup, full support, and seamless experiences for every event.",
      },
      team: {
        title: "Our Team",
        subtitle: "Meet the people behind PlayfieldVR",
        members: [
          {
            name: "Jan Angel",
            role: "Founder",
            bio: "I believe that technology brings people together and can create unforgettable moments. I want to use my passion for VR to make these experiences accessible at any desired location, so everyone can enjoy and play together.",
          },
          {
            name: "Marc Zwolsman",
            role: "Founder",
            bio: "Gaming is, in my opinion, the future of interactive entertainment. With PlayfieldVR, I want to transform events into unique experiences that enhance fun and teamwork, creating lasting memories.",
          },
        ],
      },
    },
    contact: {
      title: "Get In",
      titleHighlight: "Touch",
      description:
        "Tell us briefly what you have in mind. No strings attached: you get a tailored proposal with programme, duration and price within 24 hours.",
      emailUs: "Email Us",
      callUs: "Call Us",
      whatsappUs: "WhatsApp Us",
      whatsappCta: "Send us a WhatsApp",
      whatsappSubtitle: "Quick & low-threshold contact",
      location: "Location",
      locationText: "Active throughout the Netherlands",
      formTitle: "Send Us a Message",
      formDescription:
        "Date not fixed yet? No problem \u2013 leave your details and we\u2019ll think along, free of charge. Takes under 1 minute.",
      priceAnchor: "From € 20,- p.p.",
      priceAnchorNote: "based on full capacity of 18 people",
      form: {
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "your@email.com",
        phone: "Phone",
        phonePlaceholder: "+31 6 12345678",
        company: "Company/Organization",
        companyPlaceholder: "Your company",
        message: "Message (optional)",
        messagePlaceholder: "E.g. team building for 15 colleagues in October, at our Utrecht office...",
        submit: "Send Message",
        submitting: "Sending...",
      },
      success: "Thank you for your inquiry!",
      successDescription: "We strive to contact you within 24 hours.",
      error: "Something went wrong",
      errorDescription: "Please try again later.",
      unexpectedError: "Something went wrong. Please try again later.",
    },
    thankYou: {
      title: "Thank you for your request!",
      description: "We have received your request and will contact you within 24 hours to discuss all the details.",
      backToHome: "Back to the homepage",
    },
    footer: {
      description:
        "Next-level VR experiences delivered directly to your location. Creating unforgettable memories through immersive technology.",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      cookiePolicy: "Cookie Policy",
      copyright: "All rights reserved.",
      faq: "Frequently Asked Questions",
      faqItems: [
        {
          question: "What is PlayfieldVR?",
          answer:
            "PlayfieldVR is a 100% mobile VR service. We come to your location with professional VR equipment for team building, corporate events, and parties.",
        },
        {
          question: "How many people can participate?",
          answer: "We can accommodate groups of any size. Contact us for a customized solution for your event.",
        },
        {
          question: "What VR games do you offer?",
          answer:
            "We have an extensive selection of escape rooms, shooters, and adventure games. Check out our Games page for the full overview.",
        },
        {
          question: "What are the costs?",
          answer:
            "Costs depend on group size, duration, and chosen games. Request a free quote through our contact form.",
        },
        {
          question: "Where are you active?",
          answer:
            "We are active throughout the Netherlands and come to any desired location: offices, event venues, schools, and more.",
        },
      ],
    },
    legal: {
      privacy: {
        title: "Privacy Policy",
        lastUpdated: "Last updated",
        backToHome: "Back to Home",
        intro: {
          title: "Introduction",
          content:
            "At PlayfieldVR, we respect your privacy and take the protection of your personal data seriously. This privacy policy explains what data we collect, how we use it, and what rights you have.",
        },
        dataCollection: {
          title: "What Data Do We Collect?",
          content: "We only collect data that you voluntarily share with us through our contact form:",
          items: [
            "Name and contact details (email, phone)",
            "Company name (optional)",
            "Message or question you send us",
            "IP address and browser information (automatically collected)",
          ],
        },
        dataUsage: {
          title: "How Do We Use This Data?",
          content: "Your data is used exclusively for:",
          items: [
            "Responding to your questions and booking requests",
            "Communicating about our VR experiences and services",
            "Improving our website and service delivery",
            "Complying with legal obligations",
          ],
        },
        dataRetention: {
          title: "How Long Do We Retain Data?",
          content:
            "We retain your personal data for a maximum of 2 years after your last contact with us, unless we are legally required to retain it longer. You can always request to have your data deleted earlier.",
        },
        rights: {
          title: "Your Rights",
          content: "Under GDPR (General Data Protection Regulation), you have the following rights:",
          items: [
            "Right of access: You can request what data we have about you",
            "Right to rectification: You can have incorrect data corrected",
            "Right to erasure: You can request to have your data deleted",
            "Right to restriction: You can have the processing of your data restricted",
            "Right to object: You can object to the processing",
          ],
        },
        cookies: {
          title: "Cookies",
          content:
            "Our website uses functional cookies for language preference and YouTube embeds for game videos. For more information, see our Cookie Policy.",
        },
        contact: {
          title: "Contact",
          content:
            "For questions about your privacy or to exercise your rights, contact us through the contact form or email us directly.",
        },
      },
      terms: {
        title: "Terms of Service",
        lastUpdated: "Last updated",
        backToHome: "Back to Home",
        intro: {
          title: "Introduction",
          content:
            "These terms and conditions apply to all services and VR experiences offered by PlayfieldVR. By using our services, you agree to these terms.",
        },
        bookings: {
          title: "Bookings & Cancellations",
          content: "When booking a VR experience, the following conditions apply:",
          items: [
            "Bookings are final only after receipt of our written confirmation",
            "Cancellation up to 24 hours before scheduled time is free of charge",
            "Cancellation within 24 hours incurs 50% of total amount",
            "No-show incurs 100% of total amount",
            "We reserve the right to change prices, confirmed bookings remain at agreed price",
          ],
        },
        age: {
          title: "Age Restrictions",
          content: "For the safety of our users, we enforce the following age guidelines:",
          items: [
            "Minimum age for VR use: 13 years",
            "Children between 13-16 years need parental/guardian consent",
            "Parent/guardian must remain present during session for children under 16",
            "Certain intense experiences have higher age limits (indicated per game)",
          ],
        },
        health: {
          title: "Health & Safety",
          content: "VR can impact your health. We advise against using VR if you have:",
          items: [
            "Epilepsy or sensitivity to flashing lights",
            "Severe motion sickness or dizziness",
            "Pregnancy",
            "Heart or blood pressure problems",
            "Recent surgeries or injuries",
            "Under influence of alcohol or drugs",
          ],
        },
        safety: {
          title: "Safety Rules",
          content: "To ensure a safe and pleasant experience for everyone:",
          items: [
            "Follow all instructions from our staff",
            "Respect the VR equipment and other participants",
            "Report immediately if you feel unwell",
            "Adhere to the maximum play time we recommend",
            "Damage due to negligence or intent will be charged to the user",
          ],
        },
        liability: {
          title: "Liability",
          content:
            "PlayfieldVR is not liable for personal injury or property damage when users comply with our safety rules and instructions. Any liability of PlayfieldVR is void when instructions are deliberately ignored.",
        },
        law: {
          title: "Applicable Law",
          content:
            "These terms are governed by Dutch law. Disputes will be submitted to the competent court in the Netherlands.",
        },
      },
      cookies: {
        title: "Cookie Policy",
        lastUpdated: "Last updated",
        backToHome: "Back to Home",
        intro: {
          title: "What Are Cookies?",
          content:
            "Cookies are small text files stored on your device when you visit our website. They help us make the website function better and improve your user experience.",
        },
        functional: {
          title: "Functional Cookies",
          content: "These cookies are necessary for the website to function:",
          items: [
            "Language preference (Dutch/English) - so the site remembers your chosen language",
            "Session cookies - for proper functioning of forms and navigation",
            "Security - to prevent spam and abuse",
          ],
        },
        analytics: {
          title: "Analytics Cookies (Optional)",
          content: "We may use analytics cookies to understand how visitors use our website:",
          items: [
            "Page visits and popular content",
            "User duration and bounce rate",
            "Referring websites",
            "This data is anonymized and used only for website optimization",
          ],
        },
        thirdParty: {
          title: "Third-Party Cookies",
          content: "Our website may place third-party cookies:",
          items: [
            "YouTube - for playing game preview videos",
            "Social media widgets (Facebook, Instagram, LinkedIn, Twitter) - if you use these",
            "These parties have their own privacy policies",
          ],
        },
        manage: {
          title: "Managing Cookies",
          content:
            "You can manage cookies through your browser settings. Note: disabling functional cookies may affect the operation of our website. Consult your browser's help function for instructions.",
        },
        moreInfo: {
          title: "More Information",
          content:
            "For more information about how we handle your data, see our Privacy Policy. For questions about cookies, you can contact us.",
        },
      },
    },
  },
};
